<template>
  <div class="channel-list">

      <img class="main" :class="{ selected: 'main' == isSelected }" src="../assets/main.png" @click="setChannel('main')"></img>
      <img class="proc" :class="{ selected: 'proc' == isSelected }" src="../assets/proc.png" @click="setChannel('proc')"></img>
      <img class="dare" :class="{ selected: 'dare' == isSelected }" src="../assets/dare.png" @click="setChannel('dare')"></img>
      <img class="int" :class="{ selected: 'int' == isSelected }" src="../assets/int.png" @click="setChannel('int')"></img>
      <img class="kids" :class="{ selected: 'kids' == isSelected }" src="../assets/kids.png" @click="setChannel('kids')"></img>
      <img class="lat" :class="{ selected: 'lat' == isSelected }" src="../assets/lat.png" @click="setChannel('lat')"></img>
      <img class="radio" :class="{ selected: 'radio' == isSelected }" src="../assets/radio.png" @click="setChannel('radio')"></img>

      <!-- <a href="?channel=main"><img class="main" :class="{ selected: 'main' == isSelected }" src="../assets/main.png"></img></a>
      <a href="?channel=proc"><img class="proc" :class="{ selected: 'proc' == isSelected }" src="../assets/proc.png"></img></a>
      <a href="?channel=dare"><img class="dare" :class="{ selected: 'dare' == isSelected }" src="../assets/dare.png"></img></a>
      <a href="?channel=int"><img class="int" :class="{ selected: 'int' == isSelected }" src="../assets/int.png"></img></a>
      <a href="?channel=kids"><img class="kids" :class="{ selected: 'kids' == isSelected }" src="../assets/kids.png"></img></a>
      <a href="?channel=lat"><img class="lat" :class="{ selected: 'lat' == isSelected }" src="../assets/lat.png"></img></a>
      <a href="?channel=radio"><img class="radio" :class="{ selected: 'radio' == isSelected }" src="../assets/radio.png"></img></a> -->
  </div>
</template>

<script>
import lib from '@/lib'

export default {
  name: 'channelList',
  data() {
      return {
          isRadio: false
      }
  },
  methods: {
      setChannel(c) {
        //   if (c === 'radio') {
        //       this.isRadio = true
        //     window.location.href = 'http://new.3abn.org/sabramedia/'
        //   } else {
        //       this.$store.commit('setChannel', c)
        //   lib.fetchSchedData(this.$store.state.channel, this.$store.state.days[(this.$store.state.selectedDay) + (this.$store.state.week * 7)].dateA)
        //   }


        this.$store.commit('setChannel', c)
        lib.fetchSchedData(this.$store.state.channel, this.$store.state.days[(this.$store.state.selectedDay) + (this.$store.state.week * 7)].dateA)

      }
  },
  computed: {
      isSelected() {
          return this.$store.state.channel
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/channel-list.vue